/* unplugin-vue-components disabled */import script from "./interactDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./interactDetail.vue?vue&type=script&setup=true&lang=js"

import "./interactDetail.vue?vue&type=style&index=0&id=c004488a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c004488a"]])

export default __exports__